import { render, staticRenderFns } from "./Sidentify.vue.vue?vue&type=template&id=4c20e051"
import script from "./Sidentify.vue.vue?vue&type=script&lang=js"
export * from "./Sidentify.vue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports